import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { fetchUser, saveUser } from "../../redux/actions/userAction";
import { useToasts } from "react-toast-notifications";
import ImageUploader from "react-images-upload";
import {
  changeData,
  fetchAnagraficaWithResult,
  uploadFile,
} from "../../helpers/dbOperations";
import { Link } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import {
  Box,
  Button,
  Dialog,
  makeStyles,
  Paper,
  Tabs,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { fetchAnagrafica, fetchSendCartData } from "../../helpers/dbOperations";
import CustomerModal from "./modals/modalCustomer";
import { Modal } from "react-bootstrap";
import { Article } from "./animationList";
import ReactLoading from "react-loading";
import { DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import axios from "axios";

const MyDocuments = ({ location, userData, saveUser }) => {
  const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
    mymodal: {
      width: "20vw" /* Occupy the 90% of the screen width */,
      maxWidth: "20vw",
    },
  });
  var strings = require("../../translations/italian.json");
  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const [docs, setDocs] = useState([]);
  const [showModalCustomer, setShowModalCustomer] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [customerArray, setCustomerArray] = useState([]);
  const [onClick, setOnClick] = useState(0);
  const [idCli, setIdCli] = useState(0);
  const [inCaricamentoCheckOut, setinCaricamentoCheckOut] = useState(false);
  const [wait, setWait] = useState(false);
  const [openDialogPrezzi, setOpenDialogPrezzi] = useState(false);
  var informazioni = global.informazioni;

  var _sper = sessionStorage.getItem("personal");
  if (_sper === "undefined") _sper = null;
  const personal = _sper ? JSON.parse(_sper) : {};

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const SegliAnagrafica = (risultatoAnagrafica) => {
    setModalTitle("Scegli il cliente");
    risultatoAnagrafica.Anagrafica.map((item) => {
      item.value = item.RagSoc;
      item.id = item.IdCli;
      return item;
    });
    setCustomerArray(risultatoAnagrafica.Anagrafica);
    setOnClick(1);
    setShowModalCustomer(true);
  };
  const caricaAnagrafica = async () => {
    //console.log("carica anagrafica")
    var username = userData.user.user.username;
    var password = userData.user.user.password;
    var indexAnagraficaScelta = 0;
    var indexSede = 0;
    var risultatoAnagrafica = {};
    fetchAnagraficaWithResult({ username, password })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result)
        if (!result || !result.Anagrafica) return result;

        if (result.Anagrafica.length > 1) {
          indexAnagraficaScelta = SegliAnagrafica(result);
        } else {
          setIdCli(result.Anagrafica[0].IdCli);
          setCustomerArray(result.Anagrafica);
        }
        return result;
      });
  };
  useEffect(() => {
    setShowModalCustomer(false);
    if (userData.user.user && idCli != 0) {
      var username = userData.user.user.username;
      var password = userData.user.user.password;
      var body = JSON.stringify({ username, password, IDCli: idCli });

      var endpoint = global.endpoint + "pegaso/getDocCli";
      fetch(endpoint, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
        body: body,
        withCredentials: false,
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(result.Docs);
          setDocs(result.Docs);
        });
    }
  }, [idCli]);

  useEffect(() => {
    try {
      if (!userData.user.user.IDCli || userData.user.user.IDCli == 0) {
        //console.log("Agente")
        caricaAnagrafica();
      } else if (userData.user.user && userData.user.user.IDCli != 0) {
        var username = userData.user.user.username;
        var password = userData.user.user.password;
        var body = JSON.stringify({
          username,
          password,
          IDCli: userData.user.user.IDCli,
        });

        var endpoint = global.endpoint + "pegaso/getDocCli";
        fetch(endpoint, {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded",
          }),
          body: body,
          withCredentials: false,
        })
          .then((res) => res.json())
          .then((result) => {
            console.log(result.Docs);
            setDocs(result.Docs);
          });
      }
    } catch (err) { }
  }, []);

  function downloadFile(LIdDoc, CodSezVen, datDoc, numOrd) {
    setWait(true);
    var endpoint = global.endpoint + "pegaso/webAppDocPDF";
    var body = JSON.stringify({ IdDoc: LIdDoc });
    fetch(endpoint, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
      withCredentials: false,
    })
      .then((res) => res.blob())
      .then((blob) => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${CodSezVen}_N°${numOrd}_${datDoc}.pdf`);
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
        setWait(false);
      });
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        style={{ width: "100%" }}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function openWindowWithPost(url, data) {
    var form = document.createElement("form");
    form.target = "print_popup";
    form.method = "POST";
    form.action = url;
    form.style.display = "none";
    form.onsubmit =
      "window.open('about:blank','print_popup','width=1000,height=800');";
    for (var key in data) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    //window.open(this.href, '_blank', 'width=300,height=200');
    document.body.removeChild(form);
  }
  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.my_documents} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.my_documents + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb 
        <Breadcrumb />*/}

        <CustomerModal
          style={{ zIndex: 10000 }}
          show={showModalCustomer}
          onHide={() => {
            setShowModalCustomer(false);
            setinCaricamentoCheckOut(false);
          }}
          array={customerArray}
          title={modalTitle}
          onClick={setIdCli}
        />
        <Dialog
          open={openDialogPrezzi}
          onClose={() => setOpenDialogPrezzi(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Richiesta Inviata"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Hai richiesto l'inserimento dei prezzi su questo
              documento.
              Il servizio è soggetto a disponibilità e agli orari di ufficio.
              La tua richiesta verrà gestita nel minor tempo possibile.
              Ti invitiamo a verificare nuovamente tra breve: il
              documento sarà aggiornato con i prezzi non appena
              disponibili.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialogPrezzi(false)} color="primary" autoFocus>
              Chiudi
            </Button>
          </DialogActions>
        </Dialog>
        <div className="login-register-area pt-20">
          <div className="container">
            <div className="row">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
              />
              <Modal
                show={wait}
                transparent={true}
                dialogClassName={classes.mymodal}
              >
                <div style={{ justifyContent: "center", alignSelf: "center" }}>
                  <Article key={"spinningBubbles"}>
                    <ReactLoading type={"spinningBubbles"} color="#ABABAB" />
                  </Article>
                </div>
              </Modal>
              {(!userData.user.user?.IDCli ||
                userData.user.user?.IDCli == 0) && (
                  <div>
                    <Button onClick={() => caricaAnagrafica()}>
                      {" "}
                      Cambia cliente{" "}
                    </Button>
                  </div>
                )}
              {/*personal.IDLis && <div style={{justifyContent:"center", display:"flex",width:"100%", marginBottom:"5%"}}>
                {personal.IDLis== 34 && <a href="/files/listino_4super.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                {personal.IDLis== 33 && <a href="/files/listino_5top.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                </div>
        */}
              <AppBar position="static" color="default" style={{ zIndex: 1 }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  TabIndicatorProps={{ style: { background: "gray" } }}
                >
                  {global.aziendaID != 4 && (
                    <Tab label="Ordini" style={{ minWidth: "50%" }} />
                  )}
                  {global.aziendaID != 4 && (
                    <Tab
                      label="Documenti fiscali"
                      style={{ minWidth: "50%" }}
                    />
                  )}
                  {global.aziendaID === 4 && (
                    <Tab label="Documenti" style={{ minWidth: "100%" }} />
                  )}
                </Tabs>
              </AppBar>
              {global.aziendaID != 4 && (
                <TabPanel value={value} index={0}>
                  <div style={{}}>
                    <MaterialTable
                      actions={[
                        {
                          icon: "download",
                          tooltip: "Scarica il documento",
                          onClick: (event, rowData) => {
                            // Do save operation
                            window.open(
                              window["configPegaso"].endpointBaseReport +
                              "RptDocVen.rptdesign&i=" +
                              rowData.iddocven +
                              "&a=" +
                              rowData.IDAge +
                              "&c=" +
                              rowData.IDCli +
                              "&__format=PDF",
                              "_blank",
                              "noreferrer"
                            );

                            //downloadFile(rowData.iddocven, rowData.CodSezVen, rowData.datDoc, rowData.numOrd)
                          },
                        },
                      ]}
                      localization={{
                        pagination: {
                          labelDisplayedRows: "{from}-{to} di {count}",
                          labelRowsPerPage: "{25,100}",
                          labelRowsSelect: "righe",
                        },
                        toolbar: {
                          nRowsSelected: "{0} riga(e) selezionate",
                          searchTooltip: "Ricerca",
                          searchPlaceholder: "Ricerca",
                        },
                        header: {
                          actions: "Azioni",
                        },
                        body: {
                          emptyDataSourceMessage:
                            "Nessun ordine da visualizzare",
                          filterRow: {
                            filterTooltip: "Filtro",
                          },
                        },
                      }}
                      style={{ width: "1200" }}
                      columns={[
                        { title: "Num. ordine", field: "numOrd", type: "text" },
                        { title: "Data ordine", field: "datDoc" },
                        { title: "Stato", field: "staDoc" },
                        {
                          title: "Tot. imponibile",
                          field: "impDoc",
                          type: "currency",
                          currencySetting: {
                            locale: "it",
                            currencyCode: "eur",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        },
                        {
                          title: "Tot. iva",
                          field: "ivaDoc",
                          type: "currency",
                          currencySetting: {
                            locale: "it",
                            currencyCode: "eur",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        },
                        {
                          title: "Tot.",
                          field: "totDoc",
                          type: "currency",
                          currencySetting: {
                            locale: "it",
                            currencyCode: "eur",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        },
                      ]}
                      data={JSON.parse(
                        JSON.stringify(
                          docs.filter((doc) => {
                            return doc.FlgOrdine;
                          })
                        )
                      )}
                      detailPanel={[
                        {
                          tooltip: "Expand",
                          // render function, same as tableRef.current.props.detailPanel[0].render
                          render: (rowData) => {
                            return (
                              <div>
                                <MaterialTable
                                  localization={{
                                    pagination: {
                                      labelDisplayedRows:
                                        "{from}-{to} di {count}",
                                      labelRowsSelect: "righe",
                                    },
                                    toolbar: {
                                      nRowsSelected: "{0} riga(e) selezionate",
                                      searchTooltip: "Ricerca",
                                      searchPlaceholder: "Ricerca",
                                    },
                                    header: {
                                      actions: "Azioni",
                                    },
                                    body: {
                                      emptyDataSourceMessage:
                                        "Nessun articolo da visualizzare",
                                      filterRow: {
                                        filterTooltip: "Filtro",
                                      },
                                    },
                                  }}
                                  style={{ width: "1200" }}
                                  columns={[
                                    {
                                      title: "",
                                      field: "patIma",
                                      render: (item) => (
                                        <img
                                          src={
                                            global.baseUrlImage +
                                            item.patIma +
                                            ""
                                          }
                                          alt=""
                                          border="3"
                                          height="100"
                                        />
                                      ),
                                    },
                                    { title: "Cod. articolo", field: "codArt" },
                                    {
                                      title: "Descrizione articolo",
                                      field: "desArt",
                                      width: "10%",
                                    },
                                    { title: "Qta", field: "qtaArt" },
                                    {
                                      title: "Prezzo",
                                      field: "preArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    },
                                    {
                                      title: "Sconti",
                                      field: "Sco1",
                                      render: (item) => {
                                        return (
                                          (item.Sco1 > 0
                                            ? `${item.Sco1}% `
                                            : "") +
                                          (item.ScoLir > 0
                                            ? `${item.ScoLir} `
                                            : "")
                                        );
                                      },
                                    },
                                    {
                                      title: "Imponibile",
                                      field: "totImpArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    },
                                    {
                                      title: "Iva",
                                      field: "totIvaArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    },
                                    {
                                      title: "Totale",
                                      field: "totArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    },
                                  ]}
                                  data={rowData.det}
                                  title="Dettaglio ordine "
                                  options={{
                                    pageSize: 10,
                                  }}
                                />
                              </div>
                            );
                          },
                        },
                      ]}
                      title="Ordini"
                      options={{
                        pageSize: 10,
                        actionsColumnIndex: -1,
                      }}
                    />
                  </div>
                </TabPanel>
              )}
              {global.aziendaID === 4 && (
                <TabPanel value={value} index={0}>
                  <div style={{}}>
                    <MaterialTable
                      actions={[
                        {
                          icon: "download",
                          tooltip: "Scarica il documento",
                          onClick: (event, rowData) => {
                            // Do save operation
                            window.open(
                              window["configPegaso"].endpointBaseReport +
                              "RptDocVen.rptdesign&i=" +
                              rowData.iddocven +
                              "&a=" +
                              rowData.IDAge +
                              "&c=" +
                              rowData.IDCli +
                              "&__format=PDF",
                              "_blank",
                              "noreferrer"
                            );

                            //downloadFile(rowData.iddocven, rowData.CodSezVen, rowData.datDoc, rowData.numOrd)
                          },
                        },
                        rowData => ({
                          icon: () => <span className="material-icons">request_quote</span>,
                          tooltip: "Richiedi prezzi",
                          hidden: !rowData.FLGSENZAPREZZI,
                          onClick: (event, rowData) => {
                            axios.post(global.endpoint + "pegaso/sendMailPriceRequest", {
                              username: userData.user.user.username,
                              password: userData.user.user.password,
                              IDDocVen: rowData.iddocven
                            }).then((response) => {
                              setOpenDialogPrezzi(true);
                            });
                            //downloadFile(rowData.iddocven, rowData.CodSezVen, rowData.datDoc, rowData.numOrd)
                          },
                        }),
                      ]}
                      localization={{
                        pagination: {
                          labelDisplayedRows: "{from}-{to} di {count}",
                          labelRowsPerPage: "{25,100}",
                          labelRowsSelect: "righe",
                        },
                        toolbar: {
                          nRowsSelected: "{0} riga(e) selezionate",
                          searchTooltip: "Ricerca",
                          searchPlaceholder: "Ricerca",
                        },
                        header: {
                          actions: "Azioni",
                        },
                        body: {
                          emptyDataSourceMessage:
                            "Nessun documento da visualizzare",
                          filterRow: {
                            filterTooltip: "Filtro",
                          },
                        },
                      }}
                      style={{ width: "1200" }}
                      columns={[
                        {
                          title: "Tipo documento",
                          field: "CodSezVen",
                          type: "text",
                        },
                        {
                          title: "Num. documento",
                          field: "numOrd",
                          type: "text",
                        },
                        { title: "Data documento", field: "datDoc" },
                        { title: "Stato", field: "staDoc" },
                        { title: "A cura", field: "DesTra" },
                        {
                          title: "Tot. imponibile",
                          field: "impDoc",
                          type: "currency",
                          currencySetting: {
                            locale: "it",
                            currencyCode: "eur",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                          render: (rowData) => {
                            if (rowData.FLGSENZAPREZZI) return null;
                            else return rowData.impDoc.toFixed(2);
                          },
                        },
                        {
                          title: "Tot. iva",
                          field: "ivaDoc",
                          type: "currency",
                          currencySetting: {
                            locale: "it",
                            currencyCode: "eur",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                          render: (rowData) => {
                            if (rowData.FLGSENZAPREZZI) return null;
                            else return rowData.ivaDoc.toFixed(2);
                          },
                        },
                        {
                          title: "Tot.",
                          field: "totDoc",
                          type: "currency",
                          currencySetting: {
                            locale: "it",
                            currencyCode: "eur",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                          render: (rowData) => {
                            if (rowData.FLGSENZAPREZZI) return null;
                            else return rowData.totDoc.toFixed(2);
                          },
                        },
                      ]}
                      data={JSON.parse(JSON.stringify(docs))}
                      detailPanel={[
                        {
                          tooltip: "Expand",
                          // render function, same as tableRef.current.props.detailPanel[0].render
                          render: (rowData) => {
                            return (
                              <div>
                                <MaterialTable
                                  localization={{
                                    pagination: {
                                      labelDisplayedRows:
                                        "{from}-{to} di {count}",
                                      labelRowsSelect: "righe",
                                    },
                                    toolbar: {
                                      nRowsSelected: "{0} riga(e) selezionate",
                                      searchTooltip: "Ricerca",
                                      searchPlaceholder: "Ricerca",
                                    },
                                    header: {
                                      actions: "Azioni",
                                    },
                                    body: {
                                      emptyDataSourceMessage:
                                        "Nessun articolo da visualizzare",
                                      filterRow: {
                                        filterTooltip: "Filtro",
                                      },
                                    },
                                  }}
                                  style={{ width: "1200" }}
                                  columns={[
                                    {
                                      title: "",
                                      field: "patIma",
                                      render: (item) => (
                                        <img
                                          src={
                                            global.baseUrlImage +
                                            item.patIma +
                                            ""
                                          }
                                          alt=""
                                          border="3"
                                          height="100"
                                        />
                                      ),
                                    },
                                    { title: "Cod. articolo", field: "codArt" },
                                    {
                                      title: "Descrizione articolo",
                                      field: "desArt",
                                      width: "10%",
                                    },
                                    { title: "Qta", field: "qtaArt" },
                                    {
                                      title: "Prezzo",
                                      field: "preArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                      render: (rowData) => {
                                        if (rowData.FLGSENZAPREZZI) return null;
                                        else return rowData.preArt.toFixed(2);
                                      },
                                    },
                                    {
                                      title: "Sconti",
                                      field: "Sco1",
                                      render: (item) => {
                                        if (rowData.FLGSENZAPREZZI) return null;
                                        else
                                          return (
                                            (item.Sco1 > 0
                                              ? `${item.Sco1}% `
                                              : "") +
                                            (item.ScoLir > 0
                                              ? `${item.ScoLir} `
                                              : "")
                                          );
                                      },
                                    },
                                    {
                                      title: "Imponibile",
                                      field: "totImpArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                      render: (rowData) => {
                                        if (rowData.FLGSENZAPREZZI) return null;
                                        else
                                          return rowData.totImpArt.toFixed(2);
                                      },
                                    },
                                    {
                                      title: "Iva",
                                      field: "totIvaArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                      render: (rowData) => {
                                        if (rowData.FLGSENZAPREZZI) return null;
                                        else
                                          return rowData.totIvaArt.toFixed(2);
                                      },
                                    },
                                    {
                                      title: "Totale",
                                      field: "totArt",
                                      type: "currency",
                                      currencySetting: {
                                        locale: "it",
                                        currencyCode: "eur",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                      render: (rowData) => {
                                        if (rowData.FLGSENZAPREZZI) return null;
                                        else return rowData.totArt.toFixed(2);
                                      },
                                    },
                                  ]}
                                  data={rowData.det}
                                  title="Dettaglio documento "
                                  options={{
                                    pageSize: 10,
                                  }}
                                />
                              </div>
                            );
                          },
                        },
                      ]}
                      title="Documenti"
                      options={{
                        pageSize: 10,
                        actionsColumnIndex: -1,
                      }}
                    />
                  </div>
                </TabPanel>
              )}
              <TabPanel value={value} index={1}>
                <div style={{}}>
                  <MaterialTable
                    actions={[
                      {
                        icon: "download",
                        tooltip: "Scarica il documento",
                        onClick: (event, rowData) => {
                          window.open(
                            window["configPegaso"].endpointBaseReport +
                            "RptDocVen.rptdesign&i=" +
                            rowData.iddocven +
                            "&a=" +
                            rowData.IDAge +
                            "&c=" +
                            rowData.IDCli +
                            "&__format=PDF",
                            "_blank",
                            "noreferrer"
                          );
                          //downloadFile(rowData.iddocven, rowData.CodSezVen, rowData.datDoc, rowData.numOrd)
                        },
                      },
                      (rowData) => ({
                        icon: "local_shipping",
                        tooltip: "Traccia la spedizione",
                        hidden:
                          !rowData.DesVet?.includes("GLS") &&
                          !rowData.DesVet?.includes("BRT") &&
                          !rowData.NUMCON,
                        onClick: (event, rowData) => {
                          let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
                          if (
                            rowData.DesVet?.includes("GLS") ||
                            rowData.DesVet?.includes("BRT") ||
                            rowData.NUMCON
                          ) {
                            if (rowData.DesVet?.includes("GLS")) {
                              openWindowWithPost(
                                "https://www.gls-italy.com/it/servizi-per-destinatari/dettaglio-spedizione",
                                {
                                  filtro_codice: 0,
                                  mode: "search",
                                  numero_spedizione:
                                    "SA4431" +
                                    rowData.numOrd +
                                    "/" +
                                    rowData.datDoc.slice(-2),
                                  pagina: 1,
                                  tipo_codice: "ddt",
                                }
                              );
                              //window.open("https://gls-group.com/app/service/open/rest/IT/it/rstt001?match=SA4431"+rowData.numOrd+"&type=DDT&caller=witt002&millis=1657112781442", "Tracking", params)
                            }
                            if (rowData.DesVet?.includes("BRT")) {
                              openWindowWithPost(
                                "https://vas.brt.it/vas/sped_ricDocMit_load.hsm",
                                {
                                  DocMit:
                                    rowData.datDoc.slice(-2) + rowData.numOrd,
                                  KSU: 1221302,
                                }
                              );
                              //window.open("https://gls-group.com/app/service/open/rest/IT/it/rstt001?match=SA4431"+rowData.numOrd+"&type=DDT&caller=witt002&millis=1657112781442", "Tracking", params)
                            }
                            if (rowData.NUMCON) {
                              /*openWindowWithPost(
                                "https://vas.brt.it/vas/sped_ricDocMit_load.hsm",
                                {
                                  DocMit:
                                    rowData.datDoc.slice(-2) + rowData.numOrd,
                                  KSU: 1221302,
                                }
                              );*/
                              window.open(
                                "https://track.spedisci.online/" +
                                rowData.NUMCON,
                                "Tracking"
                              );
                            }
                          } else {
                            alert(
                              "Spedizione non disponibile o previsto RITIRO IN SEDE"
                            );
                          }
                        },
                      }),
                    ]}
                    localization={{
                      pagination: {
                        labelDisplayedRows: "{from}-{to} di {count}",
                        labelRowsPerPage: "{25,100}",
                        labelRowsSelect: "righe",
                      },
                      toolbar: {
                        nRowsSelected: "{0} riga(e) selezionate",
                        searchTooltip: "Ricerca",
                        searchPlaceholder: "Ricerca",
                      },
                      header: {
                        actions: "Azioni",
                      },
                      body: {
                        emptyDataSourceMessage:
                          "Nessun documento da visualizzare",
                        filterRow: {
                          filterTooltip: "Filtro",
                        },
                      },
                    }}
                    style={{ width: "1200" }}
                    columns={
                      global.aziendaID == 2
                        ? [
                          {
                            title: "Num. documento",
                            field: "numOrd",
                            type: "text",
                          },
                          { title: "Tipo", field: "CodSezVen", type: "text" },
                          { title: "Data documento", field: "datDoc" },
                          {
                            title: "Tot. imponibile",
                            field: "impDoc",
                            type: "currency",
                            currencySetting: {
                              locale: "it",
                              currencyCode: "eur",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          },
                          {
                            title: "Tot. iva",
                            field: "ivaDoc",
                            type: "currency",
                            currencySetting: {
                              locale: "it",
                              currencyCode: "eur",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          },
                          {
                            title: "Tot.",
                            field: "totDoc",
                            type: "currency",
                            currencySetting: {
                              locale: "it",
                              currencyCode: "eur",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          },
                          { title: "Pagato", field: "Pagato", type: "text" },
                        ]
                        : [
                          {
                            title: "Num. documento",
                            field: "numOrd",
                            type: "text",
                          },
                          { title: "Tipo", field: "CodSezVen", type: "text" },
                          { title: "Data documento", field: "datDoc" },
                          {
                            title: "Tot. imponibile",
                            field: "impDoc",
                            type: "currency",
                            currencySetting: {
                              locale: "it",
                              currencyCode: "eur",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          },
                          {
                            title: "Tot. iva",
                            field: "ivaDoc",
                            type: "currency",
                            currencySetting: {
                              locale: "it",
                              currencyCode: "eur",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          },
                          {
                            title: "Tot.",
                            field: "totDoc",
                            type: "currency",
                            currencySetting: {
                              locale: "it",
                              currencyCode: "eur",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          },
                        ]
                    }
                    data={JSON.parse(
                      JSON.stringify(
                        docs.filter((doc) => {
                          return !doc.FlgOrdine;
                        })
                      )
                    )}
                    detailPanel={[
                      {
                        tooltip: "Expand",
                        // render function, same as tableRef.current.props.detailPanel[0].render
                        render: (rowData) => {
                          return (
                            <div>
                              <MaterialTable
                                localization={{
                                  pagination: {
                                    labelDisplayedRows:
                                      "{from}-{to} di {count}",
                                    labelRowsSelect: "righe",
                                  },
                                  toolbar: {
                                    nRowsSelected: "{0} riga(e) selezionate",
                                    searchTooltip: "Ricerca",
                                    searchPlaceholder: "Ricerca",
                                  },
                                  header: {
                                    actions: "Azioni",
                                  },
                                  body: {
                                    emptyDataSourceMessage:
                                      "Nessun articolo da visualizzare",
                                    filterRow: {
                                      filterTooltip: "Filtro",
                                    },
                                  },
                                }}
                                style={{ width: "1200" }}
                                columns={[
                                  {
                                    title: "",
                                    field: "patIma",
                                    render: (item) => (
                                      <img
                                        src={
                                          global.baseUrlImage + item.patIma + ""
                                        }
                                        id={"image-prod-" + item.codArt}
                                        onError={() => {
                                          var elms = document.querySelectorAll(
                                            "[id='" +
                                            "image-prod-" +
                                            item.codArt +
                                            "']"
                                          );
                                          for (
                                            var i = 0;
                                            i < elms.length;
                                            i++
                                          ) {
                                            elms[i].src =
                                              global.placeholderImage;
                                            elms[i].style.objectFit = "contain";
                                            elms[i].style.width = "100px";
                                          }
                                        }}
                                        alt=""
                                        border="3"
                                        height="100"
                                      />
                                    ),
                                  },
                                  { title: "Cod. articolo", field: "codArt" },
                                  {
                                    title: "Descrizione articolo",
                                    field: "desArt",
                                    width: "10%",
                                  },
                                  { title: "Qta", field: "qtaArt" },
                                  {
                                    title: "Prezzo",
                                    field: "preArt",
                                    type: "currency",
                                    currencySetting: {
                                      locale: "it",
                                      currencyCode: "eur",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  },
                                  {
                                    title: "Sconti",
                                    field: "Sco1",
                                    render: (item) => {
                                      return (
                                        (item.Sco1 > 0
                                          ? `${item.Sco1}% `
                                          : "") +
                                        (item.ScoLir > 0
                                          ? `${item.ScoLir} `
                                          : "")
                                      );
                                    },
                                  },
                                  {
                                    title: "Imponibile",
                                    field: "totImpArt",
                                    type: "currency",
                                    currencySetting: {
                                      locale: "it",
                                      currencyCode: "eur",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  },
                                  {
                                    title: "Iva",
                                    field: "totIvaArt",
                                    type: "currency",
                                    currencySetting: {
                                      locale: "it",
                                      currencyCode: "eur",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  },
                                  {
                                    title: "Totale",
                                    field: "totArt",
                                    type: "currency",
                                    currencySetting: {
                                      locale: "it",
                                      currencyCode: "eur",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  },
                                ]}
                                data={rowData.det}
                                title="Dettaglio documento"
                                options={{
                                  pageSize: 10,
                                }}
                              />
                            </div>
                          );
                        },
                      },
                    ]}
                    title="Documenti fiscali"
                    options={{
                      pageSize: 10,
                      actionsColumnIndex: -1,
                    }}
                  />
                </div>
              </TabPanel>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

MyDocuments.propTypes = {
  location: PropTypes.object,
  userData: PropTypes.object,
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  setToken: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData ? state.userData : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyDocuments);
